import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { SectionLink } from "./SectionLink";
import { NAV_LINKS, SERVICES, PHONE_DISPLAY, PHONE_HREF, TAGLINE, LEGAL_NAME } from "./data";
import { TOWNS } from "./areaContent";

const heading = "font-heading text-xs font-semibold uppercase tracking-[0.18em] text-brand-cyan";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-brand-deep text-white">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-[1.2fr_0.7fr_1.2fr_0.8fr_1fr]">
      <div>
        <Logo variant="reversed" className="h-24" testId="footer-logo" />
        <p className="mt-6 font-heading text-base font-semibold text-white" data-testid="footer-tagline">{TAGLINE}</p>
        <p className="mt-2 text-sm text-white/65" data-testid="footer-legal-name">JMS = {LEGAL_NAME}</p>
      </div>
      <div>
        <p className={heading}>Quick Links</p>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.href}><SectionLink hash={l.href} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-sm text-white/75 transition-colors hover:text-white">{l.label}</SectionLink></li>
          ))}
        </ul>
      </div>
      <div>
        <p className={heading}>Services</p>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => (
            <li key={s.id}><Link to={`/services/${s.slug}`} data-testid={`footer-service-link-${s.id}`} className="text-sm text-white/75 transition-colors hover:text-white">{s.title}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <p className={heading}>Service Areas</p>
        <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3">
          {TOWNS.map((t) => (
            <li key={t.slug}><Link to={`/areas/${t.slug}`} data-testid={`footer-area-link-${t.slug}`} className="text-sm text-white/75 transition-colors hover:text-white">{t.name}</Link></li>
          ))}
          <li className="col-span-2"><Link to="/areas" data-testid="footer-area-link-hub" className="text-sm text-white/75 transition-colors hover:text-white">All service areas</Link></li>
        </ul>
      </div>
      <div>
        <p className={heading}>Contact</p>
        <a href={PHONE_HREF} data-testid="footer-phone-link" className="mt-5 flex items-center gap-2.5 font-heading text-lg font-semibold text-white transition-colors hover:text-brand-cyan">
          <Phone className="h-5 w-5 text-brand-cyan" strokeWidth={1.75} /> {PHONE_DISPLAY}
        </a>
        <p className="mt-3 text-sm text-white/65">Serving all of Chatham-Kent and surrounding areas.</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="mx-auto max-w-7xl px-5 py-6 text-xs text-white/55 sm:px-8" data-testid="footer-copyright">© 2026 JMS Technologies ({LEGAL_NAME}). All rights reserved.</p>
    </div>
  </footer>
);
